import { API_CONFIG } from '../config/api';
import { internalApi } from './internalApi';

function requireConfigured() {
  if (!API_CONFIG.INTERNAL_API_BASE_URL) {
    throw new Error('Internal wallet API base URL is not configured');
  }
}

export function isInternalWalletApiConfigured() {
  return !!API_CONFIG.INTERNAL_API_BASE_URL;
}

/**
 * @returns {Promise<{ accessible?: boolean, operations_allowed?: boolean, features?: { wallet_repayment?: boolean, wallet_credit_line?: boolean, wallet_credit_issue_requests?: boolean, list_other_user_wallets?: boolean } }>}
 */
export async function getInternalWalletB2BPing() {
  requireConfigured();
  const { data } = await internalApi.get(API_CONFIG.ENDPOINTS.INTERNAL_WALLET_PING);
  return data;
}

/**
 * @param {string} walletId
 * @param {{ amount_minor: number|string, rrn: string, repayment_date?: number|string, notes?: string }} body
 */
export async function postInternalWalletRepayment(walletId, body) {
  requireConfigured();
  const { data } = await internalApi.post(API_CONFIG.ENDPOINTS.INTERNAL_WALLET_REPAYMENT(walletId), body);
  return data;
}

/**
 * @param {string} walletId
 * @param {{ credit_line_limit_minor: number|string, notes?: string }} body
 */
export async function postInternalWalletCreditLine(walletId, body) {
  requireConfigured();
  const { data } = await internalApi.post(API_CONFIG.ENDPOINTS.INTERNAL_WALLET_CREDIT_LINE(walletId), body);
  return data;
}

/**
 * Paginated non-user wallets (VPN / internal API). Params match `listNonUserWalletsQuerySchema`:
 * `phone` and `email` are optional but mutually exclusive — the server resolves the contact to an owner uid (not a raw `owner_id` query param).
 * @param {{ page?: number, limit?: number, phone?: string, email?: string, owner_type?: string, currency?: string, status?: string, wallet_id?: string }} params
 * @returns {Promise<{ success?: boolean, page?: number, limit?: number, total?: number, wallets?: unknown[], message?: string, error?: string }>}
 */
export async function getInternalNonUserWallets(params = {}) {
  requireConfigured();
  const { data } = await internalApi.get(API_CONFIG.ENDPOINTS.INTERNAL_WALLET_NON_USER_WALLETS, { params });
  return data;
}

/**
 * Approve a credit issue request (internal / VPN).
 * @param {string} walletId
 * @param {string} requestId
 * @param {{ rrn?: string, repayment_date?: number, metadata?: Record<string, unknown>, issue?: Record<string, unknown> }} body
 */
export async function postInternalApproveCreditIssueRequest(walletId, requestId, body = {}) {
  requireConfigured();
  const { data } = await internalApi.post(
    API_CONFIG.ENDPOINTS.INTERNAL_WALLET_CREDIT_ISSUE_REQUEST_APPROVE(walletId, requestId),
    body,
  );
  return data;
}

/**
 * Reject a credit issue request (internal / VPN).
 * @param {string} walletId
 * @param {string} requestId
 * @param {{ metadata?: Record<string, unknown> }} body — e.g. `{ metadata: { notes: string } }`
 */
export async function postInternalRejectCreditIssueRequest(walletId, requestId, body = {}) {
  requireConfigured();
  const { data } = await internalApi.post(
    API_CONFIG.ENDPOINTS.INTERNAL_WALLET_CREDIT_ISSUE_REQUEST_REJECT(walletId, requestId),
    body,
  );
  return data;
}
